.dots {
  display: inline-flex;
  gap: 3px;
  align-items: center;
  vertical-align: middle;
}

.dot {
  display: inline-grid;
  place-items: center;
  width: 12px;
  height: 12px;
  border: 1.5px solid var(--line-2);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--on-fill);
}

.met {
  border-color: var(--accent);
  background: var(--accent);
}

.broken {
  border-color: var(--crit);
  background: var(--crit);
}
